// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"cdcc67c3","63":"55373b3b","211":"af4ea784","257":"13d6babf","453":"f7e8f57f","596":"945b66b2","619":"f280f05d"}[chunkId] + ".chunk.js";
};